
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root',
})
export class SharedService {

  constructor(private appConfig: AppConfigService) { }

  get getToken() {
    return localStorage.getItem('token') || sessionStorage.getItem('token');
  }

  get apiUrl() {
    return this.appConfig.apiUrl;
  }

  get apiUrl2() {
    return this.appConfig.apiUrl2;
  }

  getHeaders() {
    return {
      headers: new HttpHeaders()
        // .set('Content-Type', 'application/json')
        .set('Authorization', 'Bearer ' + this.getToken),
    };
  }

  get getUrl() {
    return this.apiUrl;
  }
  get getUrl2() {
    return this.apiUrl2;
  }
}
